import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Reset() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé");
      navigate("/login");
    } catch (e2) { toast.error(apiError(e2)); }
    setLoading(false);
  };

  return (
    <div className="vp-dark min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-8"><span className="font-display text-4xl font-bold text-white">Vision<span className="vp-accent-text">POS</span></span></Link>
        <div className="vp-card rounded-2xl p-8">
          <h1 className="font-display text-3xl font-bold text-white mb-1">Nouveau mot de passe</h1>
          <p className="text-sm text-slate-400 mb-6">Choisissez un nouveau mot de passe sécurisé</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Nouveau mot de passe</Label>
              <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="reset-password" className="bg-black/30 border-white/10 text-white" /></div>
            <Button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full vp-accent-bg text-black font-semibold">
              {loading && <Loader2 className="animate-spin mr-2" size={16} />} Réinitialiser
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
